import React, { FormEvent, useState } from "react";
import { supabase } from "./supabaseClient";
import cx from "classnames";
import { AuthError } from "@supabase/supabase-js";

export default function Auth() {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [showVerification, setShowVerification] = useState(false);

  const handleLogin = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    try {
      setLoading(true);
      const { error } = await supabase.auth.signInWithOtp({
        email,
        options: {
          emailRedirectTo: window.location.origin,
        },
      });
      if (error) throw error;
      setShowVerification(true);
      alert("Check your email for the verification code!");
    } catch (error) {
      alert((error as AuthError).cause || (error as Error).message);
    } finally {
      setLoading(false);
    }
  };

  const handleVerification = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    try {
      setLoading(true);
      const { error } = await supabase.auth.verifyOtp({
        email,
        token: verificationCode,
        type: "email",
      });
      if (error) throw error;
      window.location.reload();
    } catch (error) {
      alert((error as AuthError).cause || (error as Error).message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="homepage">
      <div className="card bg-base-100 shadow-4xl my-24 max-w-3xl mx-auto">
        <div className="card-body flex items-center">
          <img
            src="/Logo128.png"
            alt="Social Media Planner for Photographer logo"
            className="w-24 mb-4"
          />
          {!showVerification ? (
            <form
              onSubmit={handleLogin}
              className="flex items-center justify-center flex-wrap"
            >
              <input
                id="email"
                className="input  input-lg w-full mb-4"
                type="email"
                placeholder="Your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button
                className={cx(
                  "btn btn-secondary btn-lg",
                  loading && " loading"
                )}
              >
                Sign up or Login
              </button>
            </form>
          ) : (
            <form
              onSubmit={handleVerification}
              className="flex items-center justify-center flex-wrap"
            >
              <input
                id="verificationCode"
                className="input  input-lg w-full mb-4"
                type="text"
                placeholder="Enter verification code"
                value={verificationCode}
                onChange={(e) => setVerificationCode(e.target.value)}
              />
              <button
                className={cx(
                  "btn btn-secondary btn-lg",
                  loading && " loading"
                )}
              >
                Verify Code
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
